<!-- 开关闸接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkCode": "PS0AF53Q",
              "channelCode": "PS0AF4S2",
              "operator": "operator"
            },
            responseCode: {
              "data": {
                "carImageUrl": "https://openapi-dev.yidianting.xin/openydt/files/images/ead055b8-fa61-49fe-90e9-0438aaec44dc-body-unknown-pre.jpg?s=844e04c1&n=S-gZslhERFVBYyklU72fkgUKMgp64U1VJe3oY9TMBfWPbcLAcd245Z4u_0DHFQmkIFDB5xj9yFdM7edi8a9op8TPXUTkzf8FXp2uaC7MXbXInZoMZLvrPf3n_9iKHZzCvH1NjfdIblwBF-Hs68J9l16iNolwMzuFzfqTb9p63MUpY0nMsqKAAMFdTeIGD0W8frQ15WJdr_3m76prnUX0Cw",
                "plate": "未识别1697077012",
                "plateImageUrl": "https://openapi-dev.yidianting.xin/openydt/files/images/ead055b8-fa61-49fe-90e9-0438aaec44dc-body-unknown-pre.jpg?s=d7fb9105&n=S-gZslhERFVBYyklU72fkgUKMgp64U1VJe3oY9TMBfWPbcLAcd245Z4u_0DHFQmkIFDB5xj9yFdM7edi8a9op8TPXUTkzf8FXp2uaC7MXbXInZoMZLvrPf3n_9iKHZzCmSn97LQvGjE44fFi2oAzTPItrAG_jTtvOvNoC9TAxLvAbhPVxm9Vjh090th66OYOk7mXTEYwTrf6zSdGjSNaRanH7nB0X9fl_i6uF7Qtthc",
                "snapTime": "2023-10-12 10:16:52"
              },
              "message": "业务成功",
              "resultCode": 0,
              "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台手动抓拍",
                t_url: this.commonUrls.test+"channelSnap",
                p_url: this.commonUrls.prod+"channelSnap",
                precondition: "智汇云",
                fitSystem: "智汇云",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道自定义编码' },
                        { info1: 'operator', info2: '否', info3: 'String', info4: '操作员' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'plate', info2: '是', info3: 'String', info4: '车牌号' },
                      { info1: 'plateImageUrl', info2: '是', info3: 'String', info4: '车牌图片' },
                      { info1: 'carImageUrl', info2: '是', info3: 'String', info4: '车身图片' },
                      { info1: 'snapTime', info2: '是', info3: 'String', info4: '抓拍时间，格式 yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/device/channelSnap.vue